import Vue from 'vue'
import { Upload as ElUpload, Message } from 'element-ui'
import { isForbiddenFile, getForbiddenFileTip } from '@/utils/fileType'
import Area from '@/components/Area'
import Upload from '@/components/Upload'
import ImgList from '@/components/ImgList'
import Selector from '@/components/Selector'
import Adialog from '@/components/Adialog'
import Search from '@/components/Search'
import FuzzyQuery from '@/components/FuzzyQuery'
import CollapseBox from '@/components/CollapseBox'
import CollapseTableColumn from '@/components/CollapseTableColumn'
import AppAuth from '@/components/AppAuth'
import FormattedAmount from '@/components/FormattedAmount'

import Roll from '@/components/Roll'

Vue.component('Area', Area)
Vue.component('Upload', Upload)
Vue.component('ImgList', ImgList)
Vue.component('Selector', Selector)
Vue.component('a-dialog', Adialog)
Vue.component('Search', Search)
Vue.component('FuzzyQuery', FuzzyQuery)
Vue.component('CollapseBox', CollapseBox)
Vue.component('Roll', Roll)
Vue.component('CollapseTableColumn', CollapseTableColumn)
Vue.component('AppAuth', AppAuth)
Vue.component('FormattedAmount', FormattedAmount)

// ===== 上传文件安全兜底：拦截 html/svg/js/xml/exe/jsp 等危险文件类型 =====
// 用于覆盖业务页面直接手写 el-upload、未经过公共 Upload 组件的场景：
// 未显式声明 before-upload 时，默认在选文件阶段拦截
ElUpload.props.beforeUpload = {
  type: Function,
  default(file) {
    if (isForbiddenFile(file)) {
      Message.error(getForbiddenFileTip(file))
      return false
    }
    return true
  }
}

